import type {Dayjs} from 'dayjs'
import type {UserSettings} from '@package/shared'

export const formatLocalDateTime = (dayjs: Dayjs, userSettings: UserSettings): string => {
  return dayjs.toDate().toLocaleString(undefined, {
    hour12: userSettings.timeFormat === '12h',
    timeZone: userSettings.timezone,
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}
